import React, { FC } from 'react';
import PaginationMui from '@mui/material/Pagination';
import classnames from 'classnames';

import styles from 'theme/components/controls/wise/WisePagination/WisePagination.module.scss';

interface IProps {
  pagesCount: number;
  page: number;
  onChange: (page: number) => void;
}

const WisePagination: FC<IProps> = ({ pagesCount, page, onChange }) => {
  return (
    <>
      {pagesCount > 1 && (
        <div
          className={classnames(
            styles.componentWrapper,
            'StylePath-Components-Controls-Pagination'
          )}>
          <PaginationMui
            count={pagesCount}
            page={page}
            onChange={(_, page) => {
              onChange(page);
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }}
            shape="rounded"
            showFirstButton
            showLastButton
            siblingCount={1}
          />
        </div>
      )}
    </>
  );
};

export default WisePagination;
